/**
 * Softphone – qui l'a : les agents du pilote, membres du groupe Entra du softphone de l'environnement
 * (config.json › softphone.groupe, sinon GROUPE_SOFTPHONE_PILOTE, docs/DROITS.md) quand l'instance Connect est
 * déclarée ; tout le monde en maquette (démonstration). Sans instance déclarée : personne. L'agent l'active ensuite
 * dans Réglages › Téléphone (préférence `softphone`) : le bouton Téléphone apparaît alors dans le dock. Le droit
 * « lire » sur les appels est vérifié en plus par le fournisseur (Softphone.tsx).
 */
import { GROUPE_SOFTPHONE_PILOTE, type ConfigFront } from '@agora/shared';

type ConfigSoftphone = Pick<ConfigFront, 'softphone'> & { maquette: boolean };

/** Groupe Entra dont les membres ont le softphone dans cet environnement. */
export function groupeSoftphone(config: ConfigSoftphone): string {
  return config.softphone?.groupe ?? GROUPE_SOFTPHONE_PILOTE;
}

export function agentDuPilote(config: ConfigSoftphone, groupes: readonly string[]): boolean {
  if (config.maquette) return true;
  return !!config.softphone && groupes.includes(groupeSoftphone(config));
}

/**
 * Option « Téléphone » de Réglages : `absente` (pas d'instance Connect dans cet environnement), `grisee` (instance,
 * mais l'utilisateur n'est pas dans le groupe du softphone), `disponible`.
 */
export function optionSoftphone(config: ConfigSoftphone, groupes: readonly string[]): 'absente' | 'grisee' | 'disponible' {
  if (!config.maquette && !config.softphone) return 'absente';
  return agentDuPilote(config, groupes) ? 'disponible' : 'grisee';
}
